import PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Pager } from "rhombus-react";
import { ContentFeeds } from "reducers/ContentFeeds";
import { useCollectionFiltering } from "utils/DataGrid";
import { CONTENT_FEED_ROW_COUNT_OPTIONS } from "utils/constants";
import EmptySection from "widgets/EmptySection";
import Grid from "./Grid";
import ContentFeedModals from "./ContentFeedModals";
import Toolbar from "./Toolbar";
import AddContentFeedButton from "./AddContentFeedButton";

import "./ContentFeedList.css";

export default function ContentFeedList({ libraryId }) {
	const dispatch = useDispatch();
	const contentFeeds = useSelector(state => state.contentFeeds);

	const {
		filterInfo: { page, rpp, searchTerm, sort },
	} = useCollectionFiltering(
		contentFeeds,
		ContentFeeds.setAdvancedFilter,
		() => {
			dispatch(ContentFeeds.loadContentFeeds(libraryId));
		}
	);

	const items = contentFeeds?.items || [];
	const isLoading = contentFeeds?.isLoading || false;
	const isLoaded = !isLoading;

	const pagerProps = {
		showItemCount: true,
		initialPage: page,
		forcePage: page,
		pageSize: rpp,
		pageCount: contentFeeds.totalPages,
		maxItems: contentFeeds.totalItems,
		showItemWord: "",
		rowCountItems: CONTENT_FEED_ROW_COUNT_OPTIONS,
		disabled: isLoading,
		onPageChange: newPage => dispatch(ContentFeeds.setPage(newPage)),
		onRowCountChange: newRPP => dispatch(ContentFeeds.setRPP(newRPP)),
	};

	function handleSearch(newSearchTerm) {
		dispatch(ContentFeeds.setSearchTerm(newSearchTerm));
	}

	const $toolbar = (
		<Toolbar
			searchTerm={searchTerm}
			handleSearch={handleSearch}
		/>
	);

	if (isLoaded && items.length === 0) {
		let emptyProps = {
			className: "empty-content-feed",
			header: "No Bulk Sheets have been added",
			message: "Start by adding the first one",
			src: "/images/noContentFeeds.svg",
			buttons: [
				<AddContentFeedButton key="add" label="Add New" buttonStyle="inline" />,
			],
		};

		if (searchTerm) {
			emptyProps = {
				className: "empty-content-feed no-search-results",
				header: "No search results to display",
				message: "Try adjusting your search to find what you are looking for",
				src: "/images/noSearch.svg",
				buttons: [
					<Button key="clear" onClick={() => dispatch(ContentFeeds.setSearchTerm(""))}>
						Clear Search
					</Button>
				],
			};
		}

		return (
			<div className="content-feeds-grid">
				{$toolbar}
				<EmptySection {...emptyProps} />
			</div>
		);
	}

	return (
		<div className="content-feeds-grid">
			<ContentFeedModals />
			{$toolbar}
			<Grid
				contentFeeds={items}
				libraryId={libraryId}
				sort={sort}
				isLoading={isLoading}
			/>
			<Pager {...pagerProps} />
		</div>
	);
}

ContentFeedList.displayName = "ContentFeedList";

ContentFeedList.propTypes = {
	libraryId: PropTypes.string.isRequired,
};

